"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// generated by genversion
exports.version = '3.8.22';
//# sourceMappingURL=version.js.map